import { PayrollValueObjectsConceptUnitTypeEnum } from 'generated/resources/graphql'

import { toCents } from 'modules/core/lib/formatCurrencyUtils'
import MoneyWithCurrency from 'modules/core/lib/money'

function formatValue(
  value: number,
  unit: PayrollValueObjectsConceptUnitTypeEnum,
  unitSymbol: string,
  locale: string
): string {
  if (unit === 'money') {
    // TODO: this toCents here shouldn't be necessary once the input will be responsible of transforming currencies properly
    const integerValue = Number(toCents(value))
    return MoneyWithCurrency({
      optionalDecimals: true,
      amount: integerValue,
      currency: unitSymbol,
      locale,
    })
  }

  if (unit === 'time') {
    const hours = Math.floor(value / 60)
    const minutes = Math.round(value % 60)
    return minutes > 0 ? `${hours}h ${minutes}m` : `${hours}h`
  }

  return `${value} ${unitSymbol}`
}

export { formatValue }
